<template>
  <b-row class="p-0 m-0">
    <b-col lg="12" class="p-0 m-0">
      <b-col lg="12" class="m-0 p-0 text-center">
        <div
          class="mx-auto my-5 p-4 p-md-5 rounded-4 text-white shadow-lg fees-wrap"
          style="max-width: 720px; text-align: left; line-height: 1.6;"
        >
          <!-- Header -->
          <div class="text-center mb-4">
            <div class="head-icon mx-auto mb-3">
              <svg width="30" height="30" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                <path d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 0 1-.884-.884l10-10a.625.625 0 0 1 .884 0z"/>
                <path d="M5 4.5A1.5 1.5 0 1 1 2 4.5a1.5 1.5 0 0 1 3 0zm9 7A1.5 1.5 0 1 1 11 11.5a1.5 1.5 0 0 1 3 0z"/>
              </svg>
            </div>
            <h2 class="fw-bold mb-2 head-title">Комиссия Payton</h2>
            <p class="head-sub mb-0">
              Мы берём небольшой процент от суммы обмена.
              Чем больше сумма операции — тем ниже комиссия.
            </p>
          </div>

          <!-- Fees list -->
          <div class="fees-list">
            <div v-if="loading" class="fees-empty">Загружаем тарифы…</div>
            <div v-else-if="!rows.length" class="fees-empty">Тарифы временно недоступны</div>

            <div v-for="(row, index) in rows" :key="index" class="fee-row">
              <div class="fee-amount">{{ row.volume }}</div>
              <div class="fee-value">{{ row.feePercent }}</div>
            </div>
          </div>

          <!-- Note -->
          <p class="fees-note mt-4 mb-0">
            Точная сумма комиссии всегда показывается перед подтверждением операции.
          </p>
        </div>
      </b-col>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios'
import { apiDomain } from '@/config/config'

export default {
  name: 'CommissionFees',
  data() {
    return {
      tiers: [],
      loading: true,
    }
  },
  computed: {
    rows() {
      return this.tiers.map((tier) => ({
        volume: this.formatVolume(tier.fromAmount, tier.toAmount),
        feePercent: this.formatPercent(tier.percent),
      }))
    },
  },
  methods: {
    loadTiers() {
      this.loading = true
      axios.get(`${apiDomain}/exchange/commission/list`)
        .then((res) => { this.tiers = Array.isArray(res.data) ? res.data : [] })
        .catch(() => { this.tiers = [] })
        .finally(() => { this.loading = false })
    },
    formatVolume(fromAmount, toAmount) {
      const format = (value) => new Intl.NumberFormat('ru-RU').format(Math.round(value))
      if (toAmount >= 100000000) return 'от ' + format(fromAmount) + ' $'
      if (fromAmount <= 0) return 'до ' + format(toAmount) + ' $'
      return format(fromAmount) + ' – ' + format(toAmount) + ' $'
    },
    formatPercent(percent) {
      return (Number(percent || 0)).toFixed(2).replace('.', ',') + '%'
    },
  },
  created() {
    this.loadTiers()
  },
  mounted() {
    document.title = 'Комиссия Payton'
  },
}
</script>

<style scoped>
.fees-wrap {
  background: rgba(0, 0, 0, 0.86);
}

.head-icon {
  width: 64px;
  height: 64px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(135deg, #efb914, #f0a500);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35), inset 0 0 0 2px rgba(255, 255, 255, 0.15);
}

.head-title {
  font-size: clamp(1.7rem, 2vw + 1rem, 2.2rem);
  line-height: 1.15;
}
.head-sub {
  color: rgba(255, 255, 255, 0.65);
  font-size: 1rem;
  max-width: 480px;
  margin: 0 auto;
}

.fees-list {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.04);
  overflow: hidden;
}
.fee-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}
.fee-row:first-child {
  border-top: 0;
}
.fee-amount {
  font-size: 1.05rem;
  font-weight: 600;
  color: #fcfcfd;
}
.fee-value {
  font-size: 1.15rem;
  font-weight: 800;
  color: #efb914;
  white-space: nowrap;
}
.fees-empty {
  padding: 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
}

.fees-note {
  color: rgba(255, 255, 255, 0.55);
  font-size: 0.92rem;
  text-align: center;
}
</style>
